import React, { useState, useEffect } from 'react';
import { FiAlertTriangle, FiX, FiExternalLink } from 'react-icons/fi';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const RegulatoryAlertBanner = () => {
  const [alert, setAlert] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAlert();
  }, []);

  const fetchAlert = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/system/regulatory-alert`, { withCredentials: true });
      if (response.data && response.data.active) {
        // Check if user has already dismissed this alert
        const dismissedAlerts = JSON.parse(localStorage.getItem('dismissedAlerts') || '[]');
        if (!dismissedAlerts.includes(response.data.id)) {
          setAlert(response.data);
        }
      }
    } catch (error) {
      // Silently fail - alert is optional
      console.log('No regulatory alert available');
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    if (alert) {
      // Store dismissed alert ID in localStorage
      const dismissedAlerts = JSON.parse(localStorage.getItem('dismissedAlerts') || '[]');
      dismissedAlerts.push(alert.id);
      localStorage.setItem('dismissedAlerts', JSON.stringify(dismissedAlerts));
    }
    setDismissed(true);
  };

  if (loading || dismissed || !alert) {
    return null;
  }

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <FiAlertTriangle className="text-amber-500 flex-shrink-0" size={20} />
            <div className="flex-1 min-w-0">
              <span className="text-amber-200 font-medium text-sm">
                {alert.title}
              </span>
              {alert.message && (
                <span className="text-amber-200/70 text-sm ml-2">
                  — {alert.message}
                </span>
              )}
            </div>
          </div>
          
          <div className="flex items-center gap-3 flex-shrink-0">
            {alert.link && (
              <a
                href={alert.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-400 hover:text-amber-300 text-sm font-medium flex items-center gap-1 transition-colors"
              >
                Learn more
                <FiExternalLink size={14} />
              </a>
            )}
            <button
              onClick={handleDismiss}
              className="text-amber-400/60 hover:text-amber-400 transition-colors p-1"
              aria-label="Dismiss alert"
            >
              <FiX size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegulatoryAlertBanner;
